document.addEventListener('alpine:init', () => {
    Alpine.data('PressRoomFilter', (data) => {
        const items = JSON.parse(data);

        return {
            open: false,
            selectedCategory: 'all-categories',
            selectedTag: 'all-tags',
            selectedCategoryName: 'All media',
            selectedTagName: 'Alla etiketter',
            searchQuery: '',
            visibleCount: 0,
            filteredItems: items,

            init() {
                this.visibleCount = document.querySelectorAll('.item').length;
                console.log(items);
            },

            selectCategory(id, name) {
                this.selectedCategory = id;
                this.selectedCategoryName = name;

                this.filter();
            },

            selectTag(id, name) {
                this.selectedTag = id;
                this.selectedTagName = name;

                this.filter();
            },

            filter() {
                this.filteredItems = items.filter((item) => {
                    const categories = item.categories.split(',');
                    const tags = item.tags.split(',');

                    const matchesCategories = this.selectedCategory ===
                        'all-categories' ||
                        categories.indexOf(this.selectedCategory) >
                        -1;

                    const matchesTags = this.selectedTag === 'all-tags' ||
                        tags.indexOf(this.selectedTag) > -1;

                    const matchesQuery = this.searchQuery === '' ||
                        item.title.toLowerCase()
                            .indexOf(this.searchQuery.toLowerCase()) > -1 ||
                        item.excerpt.toLowerCase()
                            .indexOf(this.searchQuery.toLowerCase()) > -1 ||
                        item.content.toLowerCase()
                            .indexOf(this.searchQuery.toLowerCase()) > -1;

                    return matchesCategories && matchesTags && matchesQuery;
                });
            },
        };
    });
});

//# sourceMappingURL=pressroom-filter.js.map
